import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { profileService } from '@/services/profile-service';
import { isEmptyUUID, type UUID } from '@/utils/uuid';

import { permissionQueryKeys } from './query-keys';

/** List the current user's distinct permission names in a tenant. */
export function useListMyPermissions(
  tenantId?: UUID
): UseQueryResult<string[], Error> {
  return useQuery<string[], Error>({
    queryKey: permissionQueryKeys.myPermissions(tenantId),
    queryFn: () => profileService.listMyPermissions(tenantId as UUID),
    enabled: !isEmptyUUID(tenantId),
  });
}
